<template>
  <div>
    <div class="vx-row mb-base container">
      <div
        class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-8/12 xl:w-8/12 padding-2"
      >
        <vx-card title no-shadow card-border>
          <div class="mt-2 p-4 bg-light rounded shadow-sm">
            <!-- Header Section -->
            <div class="mb-3">
              <span class="heade_class">
                <img
                  src="@/assets/images/flags/review.png"
                  alt="Review"
                  class="image"
                />
                <h1
                  class="h4 mb-4 font-bold"
                  v-if="basketData.simType == 'Postpaid'"
                >
                  {{$t("customers.label.ContractReview")}}
                </h1>
                <h1 class="h4 mb-4 font-bold" v-else>{{$t("customers.label.Terms&Conditions")}}</h1>
              </span>
              <hr />
              <div v-if="basketData.simType == 'Postpaid'">
                <p class="text-secondary mt-3 font-bold">
                  {{$t("customers.label.ReviewThisContract")}}
                </p>
                <p class="text-secondary">
                  {{$t("customers.label.We_have_sent_these_to")}}
                  <span class="fw-bold">
                    {{ customerActivationData.clientData[0].email }}</span
                  >
                </p>
              </div>
            </div>

            <!-- Buttons Section -->
            <div class="mb-4">
              <vx-card
                class="button_sec"
                no-shadow
                card-border
                v-if="basketData.simType == 'Postpaid'"
              >
                <div class="mb-5">
                  <span>{{$t("customers.label.DownloadContractInformation")}}</span>
                  <button
                    class="download_button"
                    @click="downloadPfd('pdfContractInfo', 'contractInfoBox')"
                  >
                    <feather-icon
                      title="Download"
                      icon="DownloadCloudIcon"
                      svgClasses="w-5 h-5 stroke-current text-primary"
                      class="icon_row"
                    />
                  </button>
                  <button
                    class="view_button"
                    @click="viewContract('contractInfoBox')"
                  >
                    <feather-icon
                      title="View"
                      icon="EyeIcon"
                      svgClasses="w-5 h-5 stroke-current text-primary"
                      class="icon_row"
                    />
                  </button>
                </div>
                <hr />
                <div class="mt-5">
                  <span>{{$t("customers.label.DownloadContractSummary")}}</span>
                  <button
                    class="download_button"
                    @click="
                      downloadPfd('pdfContractSummary', 'contractSummaryBox')
                    "
                  >
                    <feather-icon
                      title="Download"
                      icon="DownloadCloudIcon"
                      svgClasses="w-5 h-5 stroke-current text-primary"
                      class="icon_row"
                    />
                  </button>
                  <button
                    class="view_button"
                    @click="viewContract('contractSummaryBox')"
                  >
                    <feather-icon
                      title="View"
                      icon="EyeIcon"
                      svgClasses="w-5 h-5 stroke-current text-primary"
                      class="icon_row"
                    />
                  </button>
                </div>
              </vx-card>
            </div>

            <vs-popup
              :icon-pack="feather"
              icon="icon-shopping-bag"
              :title="$t('customers.label.ContractInformation')"
              :active.sync="previewContractInfo"
              class="popup-close large-popup"
            >
              <div class="vx-row" id="pdfContractInfo" ref="pdfContractInfo">
                <div
                  class="p-8 max-w-3xl mx-auto hide_contract"
                  id="contractInfoBox"
                  ref="contractInfoBox"
                >
                  <!-- Header -->
                  <div class="flex items-center mb-8">
                    <img
                      src="@/assets/images/logo/lyca.png"
                      class="object-contain h-12"
                      alt=""
                    />
                    <h1 class="text-2xl font-bold ml-auto">
                      {{$t("customers.label.ContractInformation")}}
                    </h1>
                  </div>

                  <!-- Contract Details -->
                  <div
                    class="border border-gray-200 rounded-lg overflow-hidden"
                  >
                    <table class="w-full">
                      <tbody>
                        <tr>
                          <td
                            class="bg-gray-50 p-4 w-full align-top font-medium"
                          >
                            {{$t("customers.label.ContactDetails")}}
                          </td>
                          <td class="p-4">
                            {{
                              customerActivationData.clientData[0].address[0]
                                .addressNo
                            }}
                            {{
                              customerActivationData.clientData[0].address[0]
                                .district
                            }}
                            {{
                              customerActivationData.clientData[0].address[0]
                                .addressNo
                            }}
                            {{
                              customerActivationData.clientData[0].address[0]
                                .city
                            }}
                            {{
                              customerActivationData.clientData[0].address[0]
                                .state
                            }}
                            {{
                              customerActivationData.clientData[0].address[0]
                                .country
                            }}
                            {{
                              customerActivationData.clientData[0].address[0]
                                .zipCode
                            }}
                          </td>
                        </tr>

                        <tr>
                          <td class="bg-gray-50 p-4 w-48 align-top font-medium">
                            {{$t("customers.label.Description_of_Services")}}
                          </td>
                          <td class="p-4">
                            <p class="mb-4">
                              {{$t("customers.label.This_contract_summary_and_our_Abonnement_offer_of")}}
                              {
                              {{ basketData.planData[0].planName }}} {{$t("customers.label.an_airtime_service_for")}}
                              {{ basketData.planData[0].duration }} {{$t("customers.label.service_description")}}
                            </p>

                            <p class="mb-4">
                              { {{ basketData.planData[0].planName }}} {{$t("customers.label.comes_with:")}}
                            </p>

                            <ul class="list_dot pl-6 space-y-2 mb-4">
                              <li v-for="(text, i) in textArray" :key="i">
                                {{ text }}
                              </li>
                            </ul>

                            <p class="mb-2">
                              {{$t("customers.label.Any_Out_of_bundle_charges_can_be_found_at")}}
                              <a
                                href="https://abonnement.lycamobile.nl/en/rates"
                                class="text-blue-600 hover:underline"
                              >
                                https://abonnement.lycamobile.nl/en/rates
                              </a>
                            </p>

                            <p class="mb-4">
                              {{$t("customers.label.Exclusions_for_voice_international_voice_SMS_Data_Roaming_can_be_found_at")}}
                              <a
                                href="https://abonnement.lycamobile.nl/en/rates"
                                class="text-blue-600 hover:underline"
                              >
                                https://abonnement.lycamobile.nl/en/rates
                              </a>
                            </p>

                            <p class="mb-4">
                              {{$t("customers.label.Our_Services_availability")}}
                              <a
                                href="https://abonnement.lycamobile.nl/en/checkout/termsundcondition"
                                class="text-blue-600 hover:underline"
                              >
                                https://abonnement.lycamobile.nl/en/checkout/termsundcondition
                              </a>
                            </p>

                            <p class="mb-4">
                              {{$t("customers.label.Lycamobile_network_speeds")}}
                            </p>

                            <p>
                              {{$t("customers.label.Mobile_data_speed_variation")}}
                            </p>
                          </td>
                        </tr>

                        <tr>
                          <td class="bg-gray-50 p-4 w-48 align-top font-medium">
                            {{$t("customers.label.Price")}}
                          </td>
                          <td class="p-4">
                            <p class="mb-4">
                              {{$t("customers.label.DataCostDetails")}}
                            </p>

                            <p class="mb-4">
                              {{$t("customers.label.AdditionalAddons")}}
                            </p>

                            <h3 class="font-bold mb-2">{{$t("customers.label.SpendingLimits")}}</h3>
                            <p class="mb-4">
                              {{$t("customers.label.SpendingLimitDetails")}}
                            </p>

                            <p class="mb-4">
                              {{$t("customers.label.PremiumCharges")}}
                            </p>

                            <p class="mb-4">
                              {{$t("customers.label.InternationalRates")}}
                              <a
                                href="https://abonnement.lycamobile.nl/en/rates"
                                class="text-blue-600 hover:underline"
                              >
                                https://abonnement.lycamobile.nl/en/rates
                              </a>
                            </p>

                            <h3 class="font-bold mb-2">{{$t("customers.label.RoamingInEEA")}}</h3>
                            <p class="mb-4">
                              {{$t("customers.label.RoamingOutsideEEA")}}
                              <a
                                href="https://abonnement.lycamobile.nl/en/rates"
                                class="text-blue-600 hover:underline"
                              >
                                https://abonnement.lycamobile.nl/en/rates
                              </a>
                            </p>

                            <h3 class="font-bold mb-2">
                              {{$t("customers.label.RoamingOutsideEEA")}}
                            </h3>
                            <p>
                              {{$t("customers.label.RoamingCharges")}}
                              <a
                                href="https://abonnement.lycamobile.nl/en/rates"
                                class="text-blue-600 hover:underline"
                              >
                                https://abonnement.lycamobile.nl/en/rates
                              </a>
                              {{$t("customers.label.TariffTermsDetails")}}
                            </p>
                          </td>
                        </tr>

                        <tr>
                          <td class="bg-gray-50 p-4 w-48 align-top font-medium">
                            {{$t("customers.label.DeliveryOfService")}}
                          </td>
                          <td class="p-4">
                            <p class="mb-4">
                              {{$t("customers.label.PaymentTerms")}}
                            </p>
                            <p>
                              {{$t("customers.label.ServiceStartDate")}}
                            </p>
                          </td>
                        </tr>

                        <tr>
                          <td class="bg-gray-50 p-4 w-48 align-top font-medium">
                            {{$t("customers.label.ServiceAgreementTerms")}}
                          </td>
                          <td class="p-4">
                            <h3 class="font-bold mb-2">{{$t("customers.label.Duration")}}</h3>
                            <p class="mb-4">
                              {{$t("customers.label.MinimumPeriod")}}
                            </p>

                            <h3 class="font-bold mb-2">{{$t("customers.label.Renewal")}}</h3>
                            <p class="mb-4">
                              {{$t("customers.label.ContractRenewal")}}
                            </p>

                            <h3 class="font-bold mb-2">{{$t("customers.label.Termination")}}</h3>
                            <p class="mb-4">
                              {{$t("customers.label.TerminationNotice")}}
                            </p>

                            <p class="mb-4">
                              {{$t("customers.label.EarlyTerminationCharge")}}
                            </p>

                            <p class="mb-4">
                              {{$t("customers.label.OptionalAddOnTermination")}}
                            </p>

                            <p>
                              {{$t("customers.label.CancellationInfo")}}
                            </p>
                          </td>
                        </tr>

                        <tr>
                          <td class="bg-gray-50 p-4 w-48 align-top font-medium">
                            {{$t("customers.label.Security")}}
                          </td>
                          <td class="p-4">
                            <p>
                              {{$t("customers.label.SecurityPolicy")}}
                            </p>
                          </td>
                        </tr>

                        <tr>
                          <td class="bg-gray-50 p-4 w-48 align-top font-medium">
                            {{$t("customers.label.DataProtection")}}
                          </td>
                          <td class="p-4">
                            <p class="mb-4">
                              {{$t("customers.label.DataProtectionPolicy")}}
                            </p>

                            <p>
                              {{$t("customers.label.DirectoryServiceInfo")}}
                            </p>
                          </td>
                        </tr>

                        <tr>
                          <td class="bg-gray-50 p-4 w-48 align-top font-medium">
                            {{$t("customers.label.RemediesComplaints")}}
                          </td>
                          <td class="p-4">
                            <p class="mb-4">
                              {{$t("customers.label.ContactCustomerService")}}
                              <a
                                href="https://abonnement.lycamobile.nl/en/contactus"
                                class="text-blue-600 hover:underline"
                                >https://abonnement.lycamobile.nl/en/contactus</a
                              >
                            </p>

                            <p class="mb-4">
                              {{$t("customers.label.IncludeMobileNumber")}}
                            </p>

                            <p class="mb-4">
                              {{$t("customers.label.EuropeanOnlineDisputeResolution")}}
                              <a
                                href="ec.europa.eu/consumers/odr"
                                class="text-blue-600 hover:underline"
                                >{{$t("customers.label.ECWebsite")}}</a
                              >
                              {{$t("customers.label.DisputeResolutionDetails")}}
                              <a
                                href="https://www.lycamobile.nl/en/code-of-practice/"
                                class="text-blue-600 hover:underline"
                                >https://www.lycamobile.nl/en/code-of-practice/</a
                              >
                            </p>

                            <p class="mb-4">
                              {{$t("customers.label.NetherlandsLawCompliance")}}
                            </p>

                            <p>
                              {{$t("customers.label.TermsConditions")}}
                            </p>
                          </td>
                        </tr>

                        <tr>
                          <td class="bg-gray-50 p-4 w-48 align-top font-medium">
                            {{$t("customers.label.EmergencyOrganisations")}}
                          </td>
                          <td class="p-4">
                            <p class="mb-4">
                              {{$t("customers.label.EmergencyCallInstructions")}}
                            </p>

                            <p>
                              {{$t("customers.label.EmergencyCallAvailability")}}
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </vs-popup>

            <vs-popup
              :icon-pack="feather"
              icon="icon-shopping-bag"
              :title="$t('Contract Summary')"
              :active.sync="previewContractSummary"
              class="popup-close large-popup"
            >
              <div
                class="vx-row"
                id="pdfContractSummary"
                ref="pdfContractSummary"
              >
                <div
                  class="p-8 max-w-3xl mx-auto hide_contract"
                  id="contractSummaryBox"
                  ref="contractSummaryBox"
                >
                  <!-- Header Section -->
                  <div class="flex justify-between mb-8">
                    <div>
                      <h1 class="text-xl font-bold">
                        {{$t("customers.label.PlanName")}}
                        <span class="bg-orange-100 px-2">{{
                          basketData.planData[0].planName
                        }}</span>
                      </h1>
                    </div>
                    <div class="text-right">
                      <p class="font-medium">{{$t("customers.label.LycamobileBV")}}</p>
                      <p>{{$t("customers.label.Robijnlaan17")}}</p>
                      <p>{{$t("customers.label.2132WXHoofddorp")}}</p>
                      <p>{{$t("customers.label.TheNetherlands")}}</p>
                    </div>
                  </div>

                  <!-- Contract Summary Section -->
                  <section class="mb-8">
                    <h2 class="text-lg font-bold mb-4">{{$t("customers.label.ContractSummary")}}</h2>
                    <ul class="list-disc pl-5 space-y-2">
                      <li>
                        {{$t("customers.label.ContractSummaryDescription1")}}
                      </li>
                      <li>
                        {{$t("customers.label.ContractSummaryDescription2")}}
                      </li>
                      <li>
                        {{$t("customers.label.ContractSummaryDescription3")}}
                      </li>
                    </ul>
                    <p class="mt-4">
                      {{$t("customers.label.ContractSummaryValidity")}}
                      <span class="bg-orange-100 px-2">01/13/2025</span>. {{$t("customers.label.AcceptOffer")}}
                    </p>
                  </section>

                  <!-- Services Section -->
                  <section class="mb-8">
                    <h2 class="text-lg font-bold mb-4">{{$t("customers.label.Services")}}</h2>
                    <p class="mb-4">
                      {{$t("customers.label.ContractSummarys")}}
                    </p>
                    <p class="mb-4">
                      {{$t("customers.label.The")}}
                      <span class="font-medium">{{
                        basketData.planData[0].planName
                      }}</span>
                      {{$t("customers.label.ComesWith")}}
                    </p>
                    <ul class="list_dot pl-6 space-y-2 mb-4">
                      <li v-for="(text, i) in textArray" :key="i">
                        {{ text }}
                      </li>
                    </ul>
                  </section>

                  <!-- Speeds Section -->
                  <section class="mb-8">
                    <h2 class="text-lg font-bold mb-4">
                      {{$t("customers.label.MobileDataSpeeds")}}
                    </h2>
                    <p class="mb-4">
                      {{$t("customers.label.DataServiceDescription")}}
                    </p>
                    <p class="mb-4">
                      {{$t("customers.label.DataSpeedVariation")}}
                    </p>
                  </section>

                  <!-- Price Section -->
                  <section class="mb-8">
                    <h2 class="text-lg font-bold mb-4">{{$t("customers.label.Price")}}</h2>
                    <p class="mb-4">
                      {{$t("customers.label.The")}} {{ basketData.planData[0].planName }} {{$t("customers.label.costsEuro")}}
                      <span class="bg-orange-100 px-2">{{
                        basketData.planData[0].price
                      }}</span>
                      {{$t("customers.label.forTheFirst")}}
                      <span class="bg-orange-100 px-2">{{
                        basketData.planData[0].duration
                      }}</span
                      >, {{$t("customers.label.thereafterEuro")}}
                      <span class="bg-orange-100 px-2">27.00</span> {{$t("customers.label.perMonthInclusiveVAT")}}
                    </p>
                    <p class="mb-4">
                      {{$t("customers.label.additionalAddOns")}}
                    </p>
                    <p>
                      {{$t("customers.label.paymentTerms")}}
                    </p>
                  </section>

                  <!-- Duration Section -->
                  <section class="mb-8">
                    <h2 class="text-lg font-bold mb-4">
                      {{$t("customers.label.durationRenewalTermination")}}
                    </h2>
                    <p class="mb-4">
                      <span class="bg-orange-100 px-2">{{
                        basketData.planData[0].planName
                      }}</span>
                      {{$t("customers.label.minimumPeriod")}}
                    </p>
                    <p class="mb-4">
                      {{$t("customers.label.cancellationCoolingOff")}}
                    </p>
                    <p>
                      {{$t("customers.label.earlyTerminationCharge")}}
                    </p>
                  </section>

                  <!-- Features for Disabilities Section -->
                  <section class="mb-8">
                    <h2 class="text-lg font-bold mb-4">
                      {{$t("customers.label.FeaturesForEndUsersWithDisabilities")}}
                    </h2>
                    <p>
                      {{$t("customers.label.InformationSupportServices")}}
                      <a
                        href="https://abonnement.lycamobile.nl/en/contactus-us/"
                        class="text-blue-600 hover:underline"
                        >/https://abonnement.lycamobile.nl/en/contactus-us/</a
                      >
                    </p>
                  </section>

                  <!-- Information Usage Section -->
                  <section class="mb-8">
                    <h2 class="text-lg font-bold mb-4">
                      {{$t("customers.label.HowWeUseYourInformation")}}
                    </h2>
                    <p>
                      {{$t("customers.label.InformationUsageDetails")}}
                      <a
                        href="https://abonnement.lycamobile.nl/en/checkout/privacypolicy"
                        class="text-blue-600 hover:underline"
                        >https://abonnement.lycamobile.nl/en/checkout/privacypolicy</a
                      >
                    </p>
                  </section>

                  <!-- Footer Section -->
                  <section class="text-sm">
                    <p class="mb-4">
                      {{$t("customers.label.CustomerComplaints")}}
                      <a
                        href="https://www.lycamobile.nl/en/code-of-practice/"
                        class="text-blue-600 hover:underline"
                        >https://www.lycamobile.nl/en/code-of-practice/</a
                      >.
                    </p>
                    <p>
                      {{$t("customers.label.DisputeResolution")}}
                    </p>
                  </section>
                </div>
              </div>
            </vs-popup>

            <!-- Terms and conditions popup -->
            <vs-popup
              :icon-pack="feather"
              icon="icon-shopping-bag"
              :title="$t('customers.label.ContractTermsAndConditions')"
              :active.sync="showTermsNconditions"
              class="popup-close large-popup"
            >
              <termsAndConditions />
            </vs-popup>
            <!-- Agreement Section -->
            <div class="bg-light border rounded">
              <vx-card class="button_sec" no-shadow card-border>
                <h4 class="mb-4">{{$t("customers.label.TermsAndConditions")}}</h4>
                <div class="form-check">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="contractAgreement"
                    v-model="isAgreed"
                  />
                  <label for="contractAgreement" class="form-check-label">
                    {{$t("customers.label.CustomerExplanation")}}
                    <a
                      href="#"
                      class="text-primary"
                      @click.prevent="showTermsNconditions = true"
                      >{{$t("customers.label.TermsAndConditions")}}</a
                    >, {{$t("customers.label.CustomerAgreement")}}
                  </label>
                </div>
              </vx-card>
            </div>
          </div>
        </vx-card>
      </div>
      <div
        class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-4/12 xl:w-4/12 padding-2"
      >
        <div class="vx-card p-4">
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="flex items-center basketSection">
                <img src="@/assets/images/pages/basketIcon.svg" />
                <h3 class="ml-3">{{$t("customers.label.Basket")}}</h3>
              </div>
            </div>
          </div>
          <div>
            <div
              class="p-2"
              :style="
                (basketData && basketData.pairedItemSerialNumber) ||
                (basketData && basketData.serialNumber.length > 14)
                  ? {
                      border:
                        elapsedTime > 59
                          ? '4px solid #00FF00'
                          : '4px solid #FF0000',
                    }
                  : {}
              "
            >
              <span
                class="font-bold flex items-center justify-between"
                v-if="
                  (basketData && basketData.pairedItemSerialNumber) ||
                  (basketData && basketData.serialNumber.length > 14)
                "
              >
                {{$t("customers.label.NumberReservedFor")}}
                <Timer
                  @update-timer="updateElapsedTime"
                  :elapsedTime="elapsedTime"
                />
              </span>
              <p class="mb-2 text-success">
                ✅ {{$t("customers.label.YouSelected")}} {{ basketData.selectedSimText }}
              </p>
              <!-- <p v-if="basketData.itemSerialNumber" class="mb-2 text-success">
                ✅ Serial No - {{ basketData.itemSerialNumber }}
              </p>
              <p
                v-if="basketData.pairedItemSerialNumber"
                class="mb-2 text-success"
              >
                ✅ Phone No - {{ basketData.pairedItemSerialNumber }}
              </p>
              <p
                v-if="
                  basketData.simType === 'Postpaid' &&
                  basketData.serialNumber.length > 12
                "
                class="mb-2 text-success"
              >
                ✅ Serial No - {{ basketData.serialNumber }}
              </p>
              <p
                v-if="
                  basketData.simType === 'Postpaid' && basketData.phoneNumber
                "
                class="mb-2 text-success"
              >
                ✅ Phone No - {{ basketData.phoneNumber }}
              </p> -->
              <p class="mb-2 text-success">
                ✅ {{$t("customers.label.SerialNo")}} -
                {{ basketData.itemSerialNumber || basketData.serialNumber }}
              </p>
              <p class="mb-2 text-success">
                ✅ {{$t("customers.label.PhoneNo")}} -
                {{
                  basketData.phoneNumber || basketData.pairedItemSerialNumber
                }}
              </p>
            </div>
            <basket
              v-for="(data, i) in basketData.planData"
              :key="i"
              title="Bundle"
              :detailsHtml="data.text"
              :discountedPrice="data.finalPrice"
              :currencySymbol="data.currencySymbol"
              :originalPrice="data.price"
              buttonType="change"
              buttonLabel="Change"
              :planName="data.planName"
              @action="changePlan"
              :promoDetails="data.promodata"
            />
            <basket
              v-for="(data, i) in basketData.addonData"
              :key="i"
              title="Addon"
              :detailsHtml="data.text"
              :discountedPrice="data.finalPrice"
              :originalPrice="data.price"
              buttonType="change"
              buttonLabel="Change"
              :planName="data.planName"
              @action="changePlan"
            />
            <p class="mb-2 mt-2 text-success" v-if="basketData.shippingCharge">
              ✅ Shipping Charge:
              {{ basketData.shippingCharge }}
            </p>
            <div class="text-gray-700 font-semibold">
              {{$t("customers.label.TotalPrice")}}
              <span style="color: green"
                >{{ basketData.planData[0].currencySymbol }}
                {{
                  basketData.totalPrice && basketData.totalPrice.toFixed(2)
                }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-row justify-center">
      <span class="ml-1 mr-2">
        <vs-button @click="nextTab" :disabled="!isAgreed">
          {{ $t("customers.label.next") }}
        </vs-button>
      </span>
    </div>
  </div>
</template>

<script>
import basket from "../../../components/basket.vue";
import termsAndConditions from "../../../components/termCondition.vue";
import html2pdf from "html2pdf.js";
import { mapState } from "vuex";
import Timer from "@/components/Timer.vue";
export default {
  components: {
    basket,
    termsAndConditions,
    Timer,
  },
  data() {
    return {
      isAgreed: false,
      previewContractInfo: false,
      previewContractSummary: false,
      showTermsNconditions: false,
      textArray: [],
      services: [
        "Voice services: 150 Minutes (National Other Network) - 150 minutes while in EU Roaming",
        "SMS: 150 SMS (Netherlands Other Network)- 150 SMS while in EU Roaming",
        "Data services: 40 GB National data -28 GB Data while in EU Roaming",
        "International voice services:",
        "Unlimited Lyca to Lyca minutes and SMS.",
      ],
    };
  },
  computed: {
    ...mapState({
      elapsedTime: (state) => state.customerActivationNew.elapsedTime,
      basketData: (state) => state.customerActivationNew.basketData,
      customerActivationData: (state) =>
        state.customerActivationNew.customerActivationDraft,
    }),
  },
  methods: {
    updateElapsedTime(time) {
      this.$store.commit("customerActivationNew/setElapsedTime", time);
    },
    downloadPfd(pdfType, boxType) {
      this.generatePDF(pdfType, boxType);
      // setTimeout(() => {
      //   window.location.reload();
      // }, 3000);
    },
    generatePDF(pdfType, boxType) {
      const element = this.$refs[pdfType];
      const contractBox = this.$refs[boxType];
      contractBox.style.display = "block";
      contractBox.style.marginTop = "0px";
      element.style.border = "1px solid black";
      pdfType === "pdfContractInfo"
        ? html2pdf().from(element).save("contract_information.pdf")
        : html2pdf().from(element).save("contract_summary.pdf");
    },

    viewContract(boxType) {
      boxType === "contractInfoBox"
        ? (this.previewContractInfo = true)
        : (this.previewContractSummary = true);
      const contractBox = this.$refs[boxType];
      contractBox.style.display = "block";
      contractBox.style.marginTop = "0px";
    },

    handleChangeBundle() {},
    handleAction() {
      // Implement the logic to handle the action on the basket items
    },
    changePlan() {
      this.$router.push("/customers/customer_activation/plan-info");
    },
    async nextTab() {
      // try {
      //   let response = await this.$store.dispatch(
      //     "customerActivation/simpleActivationAction",
      //     this.customerActivationData
      //   );
      //   this.$swal({
      //     title: "Success",
      //     icon: "success",
      //     text: "Customer Activation Created Successfully!",
      //     type: "success",
      //   });
      //   this.$router.push(`/customers/view_customer/${response.data.clientId}`);
      // } catch (e) {
      //   this.$swal({
      //     title: "Error",
      //     icon: "error",
      //     text: "Something went wrong",
      //     type: "error",
      //   });
      // }
      this.basketData.stage = 4;
      this.$store.dispatch(
        "customerActivationNew/setBasketData",
        this.basketData
      );
      this.$router.push("/customers/customer_activation/payment");
    },
  },
  mounted() {
    if (this.basketData.planData && this.basketData.planData[0]) {
      const strippedString = this.basketData.planData[0].text;

      const textArray = strippedString
        .replace(/<\/?[^>]+(>|$)/g, "\n")
        .split("\n")
        .map((str) => str.trim())
        .filter((str) => str !== "");

      this.textArray = textArray;
    }
  },
};
</script>
<style>
.button_sec {
  background-color: #effef1;
}

.view_button {
  margin-top: -10px;
  float: right;
  width: 60px;
  height: 35px;
  border: 1px solid #2571fe;
  border-radius: 5px;
  background-color: #f8f9fa;
}

.download_button {
  margin-left: 10px;
  float: right;
  margin-top: -10px;
  width: 60px;
  height: 35px;
  border: 1px solid #2571fe;
  border-radius: 5px;
  background-color: #f8f9fa;
}

.image {
  height: 30px;
  width: 30px;
  border-radius: 50%;
  background-color: #fe8fea;
  margin-right: 7px;
  margin-top: -5px;
  padding: 5px;
}

.heade_class {
  display: flex;
}

.list_dot {
  list-style-type: disc;
}

.hide_contract {
  display: none;
}
</style>
